import * as yup from 'yup';

yup.addMethod(yup.number, 'fromNumeral', function () {
  return this.transform(function (value, originalValue) {
    if (typeof originalValue === 'number') {
      return value;
    }
    if (originalValue.length > 1) {
      // eslint-disable-next-line
      value = originalValue.replace(/[^\.\-\d]/g, '');
      return Number(value);
    }
  });
});
